import S from '../lib/pull-stream';
import cat from 'pull-cat';
import async from 'pull-async';

function Effects (apiFns) {
    return Object.keys(apiFns).reduce(function (acc, k) {
        acc[k] = function (state, msg, ev) {
            var apiFn = apiFns[k];
            return cat([
                S.once(msg.start({ op: k, req: ev })),
                async(function (cb) {
                    apiFn(ev || {}, function onResp (err, resp) {
                        if (err) {
                            return cb(null, msg.pushError({
                                message: err.message,
                                op: k
                            }));
                        }

                        cb(null, msg[k](resp.data));
                    });
                }),
                S.once(msg.resolve({ op: k, req: ev }))
            ]);
        };

        return acc;
    }, {});
}

export default Effects;
